import {orderBy, partition} from 'lodash';
import Sentry from 'lib/sentry';

const initialState = {
  categoriesConfig: [],
  categories: [],
  selectedCategory: [],
};

const getters = {
  getCategoriesConfig: (state) => {
    return state.categoriesConfig;
  },
  getCategoriesConfigAlphabetical: (state) => {
    return state.categoriesConfig.slice(0).sort((a, b) => (a.name > b.name ? 1 : -1));
  },
  getCategories: (state) => {
    let categories = orderBy(state.categories, ['order'], ['asc']);
    const [negativeCategories, positiveCategories] = partition(categories, (category) => category.order < 0);

    const additionalCategories = {
      all: {id: 'all', name: 'Semua Kategori'},
      other: {id: 'other', name: 'Lainnya'},
    };

    return [...negativeCategories, additionalCategories.all, ...positiveCategories, additionalCategories.other];
  },
  getCategoryOptions: (state) => {
    return orderBy(state.categories, ['order'], ['asc']);
  },
  getActiveCategory: (_, getters) => getters.getCategories.find((category) => category.id === getters.getActiveCategoryId),
  getActiveCategoryId: (_, getters) => getters._getSelectedCategoryId || getters._getDefaultSelectedCategoryId,
  getActiveCategories: (state) => state.selectedCategory,
  getHighestSoldCategoryId: (_, getters) => getters.getCategories.find((category) => category.name?.toLowerCase() === 'terlaris')?.id,
  _getSelectedCategoryId: (state) => state.selectedCategory[0] || '',
  _getDefaultSelectedCategoryId(_, getters) {
    // make terlaris as default selected category and Semua Kategori as a fallback
    return getters.getHighestSoldCategoryId || 'all';
  },
};

const actions = {
  fetchCategoriesConfig({commit}) {
    return this.$api
      .getNeoConfig({id: ['edukarier-categories-config']})
      .then(({data}) => {
        commit('setCategoriesConfig', data[0].data);
      })
      .catch((e) => {
        commit('setError', {categoriesConfig: true}, {root: true});
        Sentry.log('fetchCategoriesConfig', e);
      })
      .finally(() => {
        commit('setLoading', {categoriesConfig: false}, {root: true});
      });
  },
  fetchCategories({commit}) {
    commit('setLoading', {categories: true}, {root: true});

    return this.$api
      .getCategories()
      .then(({data}) => {
        commit('setCategories', data);
      })
      .catch((e) => {
        commit('setError', {categories: true}, {root: true});
        Sentry.log('fetchCategories', e);
      })
      .finally(() => {
        commit('setLoading', {categories: false}, {root: true});
      });
  },
};

const mutations = {
  setCategoriesConfig(state, list) {
    state.categoriesConfig = list.categories;
  },
  setCategories(state, list) {
    state.categories = list;
  },
  setSelectedCategory(state, category) {
    if (!category) return;

    state.selectedCategory = [category];
  },
  setSelectedCategories(state, categories) {
    state.selectedCategory = categories;
  },
};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
